var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBthTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 74,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.86568387 6.74201474 7.86568387 6.74201474 11.015625 9.734375 C12.04925171 10.71277344 12.04925171 10.71277344 13.10375977 11.7109375 C13.81201904 12.38382813 14.52027832 13.05671875 15.25 13.75 C21.76434232 19.91258062 28.32954648 26.00667675 35 32 C34.46568096 36.1123483 32.30189725 38.12656137 29.5 41.0625 C26.05597308 44.72816612 22.76854079 48.44269532 19.625 52.375 C13.51160435 59.9512439 6.88278603 67.11721397 0 74 C0 49.58 0 25.16 0 0 Z ",
    fill: "#cdf3f8",
    transform: "translate(1,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBthTriangle);
export default __webpack_public_path__ + "static/media/bthTriangle.7ba3bc3369eaad5fe5412d5cd2c21e3f.svg";
export { ForwardRef as ReactComponent };